/**
 * This module exports a CustomOptOut class that extends the OptOut class and
 * overrides the init_exclusion method.
 *
 * The CustomOptOut class is responsible for initializing the opt-out form
 * and its fields, validating the input fields, and submitting the form.
 *
 * @module CustomOptOut
 * @extends OptOut
 */
import { OptOut } from "commonAssets/components/Forms/OptOut";

import { createElement } from "commonAssets/lib/createElement";
/**
 * CustomOptOut class that extends OptOut class and overrides the
 * init_exclusion method.
 *
 * @class
 * @extends OptOut
 * @module CustomOptOut
 * @param {Object} params - The parameters object.
 */
export class CustomOptOut extends OptOut {
    notice_generic(params) {
        const genericID = createElement(
            "fieldset",
            {
                class: "col-md-6 mb-5",
                id: "notice-general",
            },
            [
                createElement(
                    "div",
                    { class: "bg-light text-dark border rounded p-3" },
                    [
                        createElement(
                            "p",
                            [],
                            [],
                            "If you did not receive a personalized Notice in the mail or via email, click below to complete an Opt-Out Form."
                        ),
                        createElement("input", {
                            type: "button",
                            class: "btn btn-primary",
                            id: "skip-guard",
                            value: params.form_options.generic_claim.submit,
                            "aria-label":
                                params.form_options.generic_claim.submit,
                        }),
                    ]
                ),
            ]
        );
        return genericID;
    }
}
